module.exports = __webpack_public_path__ + "img/rugbyleague.4dd65efd.svg";